import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  
} from "react-bootstrap"; 

export default function NSC() {
//    const [open, setOpen] = useState(0);
  

  return (
    <>
    <div className="bg-light py-5">
    
           <section className="bg-light">
                  <Container>
                    <Row className="g-4 align-items-start">
                      {/* LEFT CONTENT */}
                      <Col lg={8}>
                              <div>
                                  <h2>Central Sector Scheme on Assistance for Boosting Seed Production in Private Sector from NSC</h2>
                                  <p>Central Sector Scheme on "Assistance for Boosting Seed Production in Private Sector" is closed as per direction of Ministry of Agriculture and Farmers Welfare, and no further applications will considered under this scheme.</p>
                              </div>
                        </Col>
                                <Col lg={4}>
                                             <div className="p-4 shadow rounded right-form">
                                               <Form>
                                                 <Form.Control className="mb-3" placeholder="Name" />
                                                 <Form.Control className="mb-3" placeholder="Email" />
                                                 <Form.Control className="mb-3" placeholder="Phone" />
                                                 <Form.Control className="mb-3" placeholder="Subject" />
                                                 <Button className="w-100">Get Started</Button>
                                               </Form>
                                             </div>
                               </Col>
                      </Row>
                  </Container>
        </section>
        
    </div>
    </>    
  );
};


